// import { sample } from './lib/math'
import { random, sample } from './lib/random'
import { RGB } from './types'

// export const _palette: RGB[] = [
//   // [0, 200, 0],
//   [255, 0, 0],
//   [0, 0, 255],
//   [255, 255, 255],
//   // [0, 0, 128],
//   // [252, 2, 160],
//   [0, 0, 0],
//   [255, 255, 0]
//   // [252, 172, 1],
//   // [0, 216, 254]
// ]

// export const palette: RGB[] = [
//   [228, 127, 61],
//   [80, 130, 65],
//   [124, 45, 29],
//   [224, 79, 58],
//   [27, 70, 168],
//   [130, 174, 249],
//   [168, 54, 47],
//   [235, 74, 104],
//   [0, 0, 0]
// ]

const japan: RGB[] = [
  [0, 0, 0],
  [255, 255, 255],
  [196, 26, 71],
  [227, 134, 152],
  [248, 76, 76],
  [255, 125, 4],
  [253, 165, 5],
  [113, 113, 75],
  [156, 175, 68],
  [60, 98, 160],
  [49, 74, 114],
  [54, 80, 165],
  [164, 160, 221],
  [135, 138, 129]
]

const japanClassic: RGB[] = [
  [195, 69, 44],
  [255, 255, 255],
  [215, 216, 220],
  [190, 191, 135],
  [0, 0, 0]
]

const japanNoble: RGB[] = [
  [195, 69, 44],
  [255, 255, 255],
  [184, 190, 221],
  [92, 64, 151]
]

const japanKabuki: RGB[] = [
  [43, 43, 43],
  [221, 117, 74],
  [47, 108, 86]
]

const japanIndigo: RGB[] = [
  [38, 68, 116],
  [246, 246, 246],
  [200, 214, 224],
  [160, 160, 160],
  [128, 98, 76]
]

const japanKasana: RGB[] = [
  [178, 131, 183],
  [243, 200, 197],
  [230, 135, 136],
  [214, 81, 51],
  [180, 215, 129],
  [234, 198, 97]
]

const japanHanafuda: RGB[] = [
  [212, 45, 38],
  [105, 65, 103],
  [43, 60, 47],
  [249, 243, 81],
  [233, 160, 81],
  [1, 1, 1]
]

const japanShibui: RGB[] = [
  [128, 53, 57],
  [216, 174, 89],
  [114, 114, 61],
  [121, 135, 154],
  [94, 83, 107]
]

const japanMonochromeSepia: RGB[] = [
  [34, 29, 28],
  [226, 227, 223],
  [149, 136, 113]
]

const fullPalette: RGB[] = [
  [0, 0, 0],
  [255, 255, 255],
  [250, 10, 10],
  [10, 10, 250],
  [10, 250, 10],
  [250, 10, 250],
  // [237, 96, 52],
  [132, 192, 230],
  [252, 241, 98],
  // [180, 57, 43],
  // [112, 124, 143],
  [15, 34, 150],
  [210, 100, 63],
  [87, 148, 93],
  [30, 30, 30],
  [145, 145, 145],
  [100, 100, 100],
  [227, 144, 161],
  [228, 234, 76],
  [150, 173, 138]
  // [202, 84, 61],
  // [137, 153, 130],
  // [210, 201, 153],
  // [196, 194, 189],
  // [23, 53, 178],
  // [29, 64, 203]
]

interface NamedPalette {
  name: string
  colours: RGB[]
}
const palettes: NamedPalette[] = [
  { colours: fullPalette, name: 'Anni' },
  { colours: japanNoble, name: 'Noble' },
  { colours: japanClassic, name: 'Classic' },
  { colours: japanMonochromeSepia, name: 'MonochromeSepia' },
  // { colours: japanShibui, name: 'Shibui' },
  { colours: japanHanafuda, name: 'Hanafuda' },
  { colours: japanKasana, name: 'Kasana' },
  // { colours: japanIndigo, name: 'Indigo' },
  { colours: japanKabuki, name: 'Kabuki' }
]

let palette: RGB[] = [[0, 0, 0]]

export function getCurrentPalette(): RGB[] {
  return palette
}

// function createRandomOrderPalette(input: RGB[]): RGB[] {
//   const result: RGB[] = []
//   for (let i = 0; i < 10; i++) {
//     result.push(...shuffle(input))
//   }
//   return result
// }

export const backgroundGradient: [RGB, RGB] = [
  [76, 76, 76],
  [190, 190, 190]
]

export function samplePalette(input: RGB[], seed: number): RGB[] {
  const selection: RGB[] = []
  const result: RGB[] = []
  const size = random(++seed, 10) + 3

  for (let i = 0; i < size; i++) {
    selection.push(sample(++seed, input) as RGB)
  }
  if (random(++seed, 99) >= 50) {
    return selection
  }

  const repeat = random(++seed, 99) + 3

  for (let i = 0; i < repeat; i++) {
    result.push(sample(++seed, selection)!)
  }
  return result
}

export function resetPalette(seed: number): void {
  const inputPalette = sample(seed + 0x818a, palettes)
  console.log('Reset Palette to', inputPalette.name)
  palette = samplePalette(inputPalette.colours, seed)
  console.log(palette)
  const bgColour1Index = random(++seed, inputPalette.colours.length - 1)
  const bgColour2Index = random(
    seed * 2 + 232347,
    inputPalette.colours.length - 1
  )
  console.log(bgColour1Index, bgColour2Index)
  backgroundGradient[0] = inputPalette.colours[bgColour1Index]
  backgroundGradient[1] = inputPalette.colours[bgColour2Index]
  console.log(backgroundGradient)
}
